import { render, staticRenderFns } from "./multipleItem.vue?vue&type=template&id=85dba58c&scoped=true"
import script from "./multipleItem.vue?vue&type=script&lang=js"
export * from "./multipleItem.vue?vue&type=script&lang=js"
import style0 from "./multipleItem.vue?vue&type=style&index=0&id=85dba58c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dba58c",
  null
  
)

export default component.exports